import React, { Component } from "react";
import { baseurl } from "../config/Settings";
import {getMyNewsletters,removeNewsletters,addNewsletters,getAPPNewslettersList} from '../config/Variables';
export default class FetchNewsletter extends Component {
  
    constructor() {
        super();
        this.state = {
          hobbies: [],
          tid: '',
          messagelog: '',
          isLoading: true,
          users: [],
          checkall: "",
          numberstid: [],
          error: null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.Removetid = this.Removetid.bind(this);
        let user = JSON.parse(localStorage.getItem('user-info'))
        let datt = fetch(getMyNewsletters, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Accept": 'application/json',
            "Authorization": "Bearer " + user.token.access_token,
          },
          body: JSON.stringify(this.state)
        }).then(response => response.json())
          .then(data => {
            if(data.webmsg.code==401){
              localStorage.clear();
              var domainurl=  window.location.origin;
              window.location.href = domainurl+'/journey';
            }
            data.data.map(({ tid }, index2) => {
              this.state.numberstid.push(tid);
              //this.setState({ numberstid: [this.state.numberstid, tid] })
              this.setState({ numberstid: this.state.numberstid })
              this.state.hobbies.push(tid);
            });
          });
      }



        handleInputChange(event) {

        const target = event.target;
        var value = target.value;


        if(target.checked){
          var selectedId1='span-'+value; 
              document.getElementById(selectedId1).innerHTML = "مشترك";
            this.state.hobbies.push(value);
        }else{
          var selectedId1='span-'+value; 
          document.getElementById(selectedId1).innerHTML = "اشترك";
        this.state.hobbies.splice(value, 1);
        }
        }
        chechallfunc() {
        this.setState({ checkall: "checked" });
        this.state.users.map(({ name, id,image,description,date }, index) => {
          this.state.hobbies.push(id);
        });
        
        }

        async Removetid(event) {

            const target = event.target;
              var value = target.value;
              var selectedId1='span-'+value; 
              document.getElementById(selectedId1).innerHTML = "اشترك";
              if (event.target.checked) {
                this.state.hobbies.push(value);
               // this.setState({messagelog:"اختر الكاتب المفضل لديك"});
              } else {
            const index = (this.state.hobbies).indexOf(parseInt(value, 2));
           
          
            for( var i = 0; i < this.state.hobbies.length; i++){ 
              
              if ( this.state.hobbies[i] == value) { 
                this.state.hobbies.splice(i, 1); 
              }
          
          }
                if (localStorage.getItem('user-info')) {
                  const tid = value
          
                  let item = { tid };
                  let user = JSON.parse(localStorage.getItem('user-info'))
                  let result =  await fetch(removeNewsletters, {
                    method: 'POST',
                    headers: {
                      "Content-Type": "application/json",
                      "Accept": 'application/json',
                      "Authorization": "Bearer " + user.token.access_token,
                    },
                    body: JSON.stringify(item)
                  });
                  result = await result.json();
            
                  if (result.message.code == '200') {
                    //localStorage.setItem("user-info", JSON.stringify(result));
                    //history('/add');
          
                  }
                }
               // this.state.hobbies.splice(value, 1);
              }
              
            }


        async submit(){
          const tid=this.state.hobbies.join(',')
        
           let item = { tid };
            if(localStorage.getItem('user-info')){
                 let user = JSON.parse(localStorage.getItem('user-info'))
                    let result =  await fetch(addNewsletters, {
                        method: 'POST',
                        headers: {
                        "Content-Type": "application/json",
                        "Accept": 'application/json',
                        "Authorization":"Bearer "+user.token.access_token,
                        },
                        body: JSON.stringify(item)
                    });
                    result = await result.json();
              
                    if(result.message.code =='200'){
                      window.dataLayer = window.dataLayer || [];

                      window.dataLayer.push({
                        event: 'personalize_newsletter',
                        user_id: user.user.id,
                        personalize_newsletters: tid
                        });
                         this.props.samirCallback("success");
                     }
                     if(result.message.code =='401'){
                      this.props.samirCallback("logout");
                    }
                    }  
                    
        console.warn(this.state)
        }
      getFetchNewsletter() {
          this.setState({
              loading: true
          }, () => {
              fetch(getAPPNewslettersList).then(res => res.json()).then(result => this.setState({
                  loading: false,
                  users: result.data
              })).catch(console.log);
          });
      }
      componentDidMount() {
          this.getFetchNewsletter();
      }
      
      render() {
          const {
              users,
              error,
              checkall,
              loading
          } = this.state;
          return (
            <div className="personal-wrap personal-wrap-newsletter"> 
            <div className="personal-wrap-before"> 
                <div className="progress-container">
                    <div className="progress" id="progress"></div>
                    <div className="progress-circle">1</div>
                    <div className="progress-circle">٢</div>
                    <div className="progress-circle active">٣</div>
                </div>
    
                <div className="function-info">
                <h3>نشراتك البريدية​</h3>
                                    <p>احصل على آخر التحديثات عبر بريدك الإلكتروني </p>
                </div> 
    
                <div className="select-list">  
                    <div className="select-list-inner" id="scroller"> 
                        <div className="newsletter-list inner-scroll">  
                         
                        {loading ?<div className="loading-mypage" ><img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?ss" /></div>: ""}
                                    <React.Fragment>
             {
                     users.map(({ name, id,image,description,date }, index) => {
                        const fruitss = this.state.numberstid;
                       
                        const ttt = parseInt(id);
                  
                        const ss = fruitss.includes(ttt); //true
                        if (ss) {
                          return (
                            <div className="newsletter-item">
                                <div className="newsletter-item-icon">
                                 <img src={`https://aawsat.com/themes/custom/aawsatv3/assets-react/img/newsletter/${id}.svg?sssssassd`} />    
                               </div>  
                              <div className="newsletter-item-info">
                                  <div className="newsletter-item-title">
                                      <h3>{name}</h3> 
                                  </div>
                                  <div className="newsletter-item-meta">
                                      <span className="meta-duration">{date}</span> 
                                  </div>
                                  <div className="newsletter-item-content show-for-large">
                                      <p>
                                      {description ? description : "طريقة لكتابة النصوص في النشر والتصميم الجرافيكي تستخدم بشكل شائع لتوضيح الشكل"}
                                      </p>
                                  </div> 
                              </div>    
                          <div className="newsletter-item-action">
                                  <label htmlFor={`custom-checkbox-${index}`} className="multi-check">
                                  <input type="checkbox" defaultChecked={true} onTouchEnd={this.Removetid} onClick={this.Removetid} defaultValue={`${id}`}  id={`custom-checkbox-${index}`} name="hobbies"  className="form-check"  onChange={this.handleInputChange}/>   
                                  <div className="checkbox-button ico-envelop">
                                      <i className="icomoon-icon icon-envelop2"></i>
                                      <span  id={`span-${id}`} >مشترك</span>
                                  </div>
                              </label> 
                          </div>
                      </div>
                      

                          );
    
                        } else {
                          return (
                            

                            <div className="newsletter-item">
                                <div className="newsletter-item-icon">
                                <img src={`https://aawsat.com/themes/custom/aawsatv3/assets-react/img/newsletter/${id}.svg?sssssssfss`} />       
                               </div>  
                              <div className="newsletter-item-info">
                                  <div className="newsletter-item-title">
                                      <h3>{name}</h3> 
                                  </div>
                                  <div className="newsletter-item-meta">
                                      <span className="meta-duration">{date}</span> 
                                  </div>
                                  <div className="newsletter-item-content show-for-large">
                                      <p>
                                      {description ? description : "طريقة لكتابة النصوص في النشر والتصميم الجرافيكي تستخدم بشكل شائع لتوضيح الشكل"}
                                      </p>
                                  </div> 
                              </div>    
                          <div className="newsletter-item-action">
                              <label htmlFor={`custom-checkbox-${index}`}  className="multi-check"> 
                            
                              { checkall =="checked" ? <input  defaultChecked={true}   type="checkbox" id={`custom-checkbox-${index}`} name="hobbies" value={`${id}`} className="form-check"  onChange={this.handleInputChange}/>:<input     type="checkbox" id={`custom-checkbox-${index}`} name="hobbies" value={`${id}`} className="form-check"  onChange={this.handleInputChange}/>} 
                              
                              <div className="checkbox-button ico-envelop">
                                      <i className="icomoon-icon icon-envelop2"></i>
                                      <span  id={`span-${id}`} >اشترك</span>
                                  </div>
                              
                                 
                              </label> 
                          </div>
                      </div>
                          );
                        }
                      })
                  }
                    </React.Fragment>  
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="personal-wrap-after">
                <div className="action-btn">
                   
                    <button  onClick={()=>this.submit()} className="button primary rounded next-btn">التالي  </button>
                </div> 
            </div>  
        </div> );}
      }
